import React from "react";
import {Switch} from "antd";
import {
    OtherHexagonsContainer,
    OtherHexagonsHeader,
    ColorLabelContainer,
    ColorSquare,
    LabelText
} from "./H3MapTools.styles";
import {TileLayerControl} from "../../_defaultComponents/TileLayerControl/TileLayerControl";
import {H3MapConfig} from "../config";

export const OtherHexagonsPanel = ({
    showOtherHexagons,
    setShowOtherHexagons,
    mapInstance,
    tileLayerRef
}) => {
    return (
        <OtherHexagonsContainer
            style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: 1000,
                backgroundColor: "#fff",
                borderRadius: "16px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                padding: "8px 12px"
            }}
        >
            <OtherHexagonsHeader>
                <ColorLabelContainer>
                    <ColorSquare color={H3MapConfig.hexagons.OTHER.color} />
                    <LabelText>Diğer Hexagonları Göster</LabelText>
                </ColorLabelContainer>
                <Switch checked={showOtherHexagons} onChange={setShowOtherHexagons} size="small" />
            </OtherHexagonsHeader>

            {/* Tile Layer Control */}
            {mapInstance && tileLayerRef && (
                <div style={{marginTop: "8px", paddingTop: "8px", borderTop: "1px solid #f0f0f0"}}>
                    <TileLayerControl
                        mapInstance={mapInstance}
                        tileLayerRef={tileLayerRef}
                        width="100%"
                    />
                </div>
            )}
        </OtherHexagonsContainer>
    );
};
